/**
 * Display + tel: helpers for stored phone numbers (US/Canada NANP focus).
 * Unrecognized patterns are returned trimmed unchanged.
 */

function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

/** NANP national number (10 digits) when input is 10 digits or 11 with leading 1. */
function nanpNationalDigits(value: string): string | null {
  const digits = digitsOnly(value);
  if (digits.length === 10) return digits;
  if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
  return null;
}

/**
 * Friendly display, e.g. `+1 (877) 542-2630` for US/Canada numbers.
 */
export function formatPhoneDisplay(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  const national = nanpNationalDigits(trimmed);
  if (!national) return trimmed;

  return `+1 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}

/** `tel:` href with a sensible +1 prefix for NANP numbers. */
export function phoneTelHref(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  const digits = digitsOnly(trimmed);
  if (!digits) return "";

  const national = nanpNationalDigits(trimmed);
  if (national) return `tel:+1${national}`;

  return trimmed.toLowerCase().startsWith("tel:") ? trimmed : `tel:${digits}`;
}
